import { useNavigate } from "react-router-dom";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

function PollingModeIndicator() {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate("/settings/troubleshooting")}
      title="Live streaming is unavailable. Headlines are updating via periodic polling instead. Click for troubleshooting info."
      className="group relative flex items-center gap-1 px-1.5 py-0.5 no-drag cursor-pointer text-amber-600 dark:text-amber-400 hover:text-amber-700 dark:hover:text-amber-300 transition-colors"
    >
      <span className="text-2xs font-medium">Polling</span>
      <InformationCircleIcon className="size-3" />
    </button>
  );
}

export default PollingModeIndicator;
